<div class="app-container">
  <pop-side-menu *ngIf="showSideMenu"></pop-side-menu>

  <div class="app-container-content"
       [class.full-width]="!showSideMenu">
    <router-outlet></router-outlet>
  </div>

  <div class="license-overlay"
       *ngIf="overlay"></div>


  <!--foooter-->

  <pop-save-timer #savetimer> </pop-save-timer>
</div>
